const URL_SEARCH_PARAMS = new URLSearchParams(window.location.search);

export const getExamIdFromQuery = (): string => URL_SEARCH_PARAMS.get('examId') as string;
export const getExamAppTokenFromQuery = (): string => URL_SEARCH_PARAMS.get('examAppToken') as string;
